<template>
    <div class="confirmar_identidad">
        <!-- Diálogo de visualización -->
        <v-dialog v-model="dialog" max-width="900px">
        <v-card>
            <v-toolbar flat color="primary" dark>
            <v-toolbar-title>Visualizador de Archivo</v-toolbar-title>
            <v-spacer></v-spacer>

            <!-- Botón Descargar -->
            <v-btn icon @click="downloadFile" :disabled="!fileUrl">
                <v-icon>cloud_download</v-icon>
            </v-btn>

            <!-- Botón Cerrar -->
            <v-btn icon @click="dialog = false">
                <v-icon>close</v-icon>
            </v-btn>
            </v-toolbar>

            <v-card-text>
            <!-- PDF -->
            <div v-if="isPdf" style="height: 80vh;">
                <iframe
                :src="fileUrl"
                width="100%"
                height="100%"
                frameborder="0"
                ></iframe>
            </div>

            <!-- Imagen -->
            <div v-else style="text-align: center;">
                <img
                :src="fileUrl"
                alt="Imagen"
                style="max-width: 100%; max-height: 80vh; border-radius: 8px;"
                />
            </div>
            </v-card-text>
        </v-card>
        </v-dialog>
        <v-container class="text-xs-center">
            <v-dialog
                    v-model="dialog_seguro"
                    persistent
                    width="300"
            >
                <v-card class="justify-center">
                    <v-card-title
                            class="warning display-1 text--primary justify-center"
                            primary-title
                    >
                        {{$t('aviso')}}
                    </v-card-title>
                    <v-card-text class="text-xs-center">
                        <h4>{{$t('pgt_seguro')}}</h4>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn color="primary" @click="dialog_seguro = false">No</v-btn>
                        <v-spacer/>
                        <v-btn color="primary" @click="eliminar_invitado()">{{$t('Si')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog
                    v-model="dialog_bloqueo"
                    persistent
                    width="500"
            >
                <v-card class="justify-center">
                    <v-card-title
                            class="warning display-1 text--primary justify-center"
                            primary-title
                    >
                        {{$t('aviso')}}
                    </v-card-title>
                    <v-card-text class="text-xs-center">
                        <h2>{{$t('pagina_caduca')}}</h2>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn
                                color="primary"
                                large
                                to="/home"
                        >
                            <v-icon left>home</v-icon>
                            {{$t('inicio')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogConfirmar" max-width="380">
                <v-card class="justify-center">
                    <v-card-title
                            class="warning display-1 text--primary justify-center"
                            primary-title
                    >
                        {{$t('confirmar_identidad')}}
                    </v-card-title>
                    <v-card-text class="text-xs-center">
                        Selecciona <b>Sí</b> o <b>No</b>, para confirmar la Identidad.
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn color="primary" @click="dialogConfirmar = false">{{$t('aceptar')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-layout calign-center justify-center fill-height>
                <v-card width="800">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('confirmar_identidad')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <!-- <v-layout row wrap>
                            <v-flex
                                    class="edge pl-3 pr-3 pt-3 pb-3"
                                    xs12 sm6
                            >
                                <v-img
                                        v-if="info.length > 0"
                                        readonly
                                        outlined
                                        :src="info[0].avatar"
                                ></v-img>
                            </v-flex>
                            <v-flex
                                    class="edge pl-3 pr-3 pt-3 pb-3"
                                    xs12 sm6
                            >
                                <v-img
                                        v-if="info.length > 0"
                                        readonly
                                        outlined
                                        :src="info[0].ine_frente"
                                ></v-img>
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <br> -->
                        <v-layout row wrap>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-if="info.length > 0"
                                        prepend-icon="mdi-account"
                                        :label="$t('Nombre')"
                                        :value="info[0].first_name"
                                        readonly
                                        outlined
                                >
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-if="info.length > 0"
                                        prepend-icon="mdi-account-outline"
                                        :label="$t('Apellido')"
                                        :value="info[0].last_name"
                                        readonly
                                        outlined
                                >
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-if="info.length > 0"
                                        prepend-icon="mdi-email"
                                        label="E-Mail"
                                        :value="info[0].email"
                                        readonly
                                        outlined
                                >
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-if="info.length > 0"
                                        prepend-icon="mdi-cellphone"
                                        :label="$t('celular')"
                                        :value="info[0].celular"
                                        readonly
                                        outlined
                                >
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                            <br></br><h3 class="headline mb-0" v-if="documentacion.length > 0">Documentos Adjuntos</h3><br></br>
                            <v-layout v-if="documentacion.length > 0" wrap class="text-xs-center">
                                <template v-for="(doc, key) in documentacion">
                                <v-flex xs12 sm6 :key="`preview-${key}`" class="mb-4">
                                    <v-card outlined class="pa-3">
                                    <div class="font-weight-bold">{{ doc.idDocumentation.name }}</div>
                                    <div class="grey--text text--darken-1 text-truncate" style="max-width: 100%;">
                                        Archivo adjunto
                                    </div>
                                    <v-btn
                                        small
                                        color="primary"
                                        class="mt-2"
                                        @click="openDialog(doc.file)"
                                        :disabled="!doc.file"
                                    >
                                        Visualizar
                                    </v-btn>
                                    </v-card>
                                </v-flex>
                                </template>
                            </v-layout>
                        {{ $t('msg_know_guest') }}
                        <v-radio-group
                                class="justify-center"
                                row
                                v-model="confirmar"
                                name="confirmar"
                                :mandatory="false"
                        >
                            <v-radio outlined :label="$t('Si')" value=true></v-radio>
                            <v-radio outlined label="No" value=false></v-radio>
                        </v-radio-group>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn
                                color="primary"
                                :loading="loading"
                                @click="confirmar_identidad()"
                        >
                            {{$t('enviar')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import store from '@/store'
    import { mapGetters } from 'vuex'

    export default {
        name: "confirmar_identidad2",
        data () {
            return {
                confirmar: null,
                dialogConfirmar: false,
                errores: [],
                info: '',
                loading: false,
                dialog_bloqueo: false,
                dialog_seguro: false,
                dialog: false,
                documentacion: [],
                isPdf: false,
                fileUrl: '',
                ineFront: {
                    "id": 1000,
                    "idDocumentation": {
                        "id": 1000,
                        "name": "INE Frente"
                    },
                    "file": "https://intrare-empresa-test.s3.amazonaws.com/media/Documentation/%2B528887773233/picture.jpeg",
                    "idUser": 419
                },
                ineBack: {
                    "id": 1001,
                    "idDocumentation": {
                        "id": 1001,
                        "name": "INE Reverso"
                    },
                    "file": "https://intrare-empresa-test.s3.amazonaws.com/media/Documentation/%2B528887773233/picture.jpeg",
                    "idUser": 419
                },
            }
        },
        created: async function(){
            // console.log('PATHHHHH = ', localStorage.getItem('path_confirmed'))
            //Obtener los Datos del Invitado
            await this.get_info_new_guest()
        },
        computed: {
            ...mapGetters(['getProfile'])
        },
        methods:{
            openDialog(fileUrl) {
                // 🔧 Ajusta esta ruta a tu estructura de archivos
                this.isPdf = fileUrl.toLowerCase().endsWith('.pdf')
                this.fileUrl = fileUrl
                this.dialog = true
            },
            downloadFile() {
                const link = document.createElement('a')
                link.href = this.fileUrl
                link.download = this.fileName
                link.target = '_blank'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            },
            confirmar_identidad: function () {
                console.log('Confirmar Identidad = ', this.confirmar)
                if(this.confirmar == null){
                    this.dialogConfirmar = true
                }
                if(this.confirmar == 'true'){
                    if (this.getProfile.roll === 4) {
                        this.loading = true
                        const config = {
                            method: 'patch',
                            url: 'https://empresa-service.intrare.app/InvitationPark/validate_guest/' + this.info[0].id,
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': 'Token ' + store.getters.getToken,
                                'Accept-Language': this.language,
                            }
                        };
                        axios(config)
                            .then(ok => {
                                this.loading = false
                                this.$router.push({ path: '/confirmar_exito' })
                            })
                            .catch(error => {
                                if(error.response && error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data){
                                    this.errores = error.response.data
                                    this.$store.commit('snackbar_activate_true')
                                    this.$store.commit('snackbar_change_color', 'error')
                                    this.$store.commit('snackbar_change_message', this.errores[0])
                                    setTimeout(this.clear, 3000)
                                }
                                else
                                if(error.response.status == 404)
                                {
                                    console.log(error.response.data.detail)
                                    this.$store.commit('snackbar_activate_true')
                                    this.$store.commit('snackbar_change_color', 'error')
                                    this.$store.commit('snackbar_change_message', error.response.data.detail)
                                    setTimeout(this.clear, 3000)
                                    this.$store.commit('snackbar_change_color', 'success')
                                    this.$store.commit('snackbar_activate_false')
                                }
                            })
                            .finally(() => (this.loading = false))
                    } else {
                        this.loading = true
                        const config = {
                            method: 'patch',
                            url: 'https://empresa-service.intrare.app/activateUser/',
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': 'Token ' + store.getters.getToken,
                                'Accept-Language': this.language,
                            },
                            data:{
                                usrToken: this.$route.params['token']
                            }
                        };
                        axios(config)
                            .then(ok => {
                                this.loading = false
                                this.$router.push({ path: '/confirmar_exito' })
                            })
                            .catch(error => {
                                if(error.response && error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data){
                                    this.errores = error.response.data
                                    this.$store.commit('snackbar_activate_true')
                                    this.$store.commit('snackbar_change_color', 'error')
                                    this.$store.commit('snackbar_change_message', this.errores[0])
                                    setTimeout(this.clear, 3000)
                                }
                                else
                                if(error.response.status == 404)
                                {
                                    this.$store.commit('snackbar_activate_true')
                                    this.$store.commit('snackbar_change_color', 'error')
                                    this.$store.commit('snackbar_change_message', this.errores[0])
                                    setTimeout(this.clear, 3000)
                                    this.$store.commit('snackbar_change_color', 'success')
                                    this.$store.commit('snackbar_activate_false')
                                }
                            })
                            .finally(() => (this.loading = false))
                    }
                }
                else
                if(this.confirmar == 'false'){
                    this.dialog_seguro = true
                }
            },
            eliminar_invitado(){
                //llamar al endpoint para eliminar usuario
                const config = {
                    method: 'POST',
                    url: 'https://empresa-service.intrare.app/NoActivateUser/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken,
                        'Accept-Language': this.language,
                    },
                    data:{
                        token: this.$route.params['token'],
                        cellNumber: this.info[0].celular
                    }
                }
                axios(config)
                .then(ok => {
                  console.log(ok)
                  this.$router.push({ path: '/confirmar_desconocido' })
                })
                .catch(error => {
                  console.log(error)
                })
            },
            getDocumentationByUser (user) {
                this.documentacion = []
                this.loading = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/get-documents-by-user/' + user.id + '/',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                };
                axios(config)
                    .then(response => {
                        this.documentacion = response.data
                        this.ineFront.file = user.ine_frente
                        this.ineBack.file = user.ine_atras
                        this.documentacion.push(this.ineFront)
                        this.documentacion.push(this.ineBack)
                        console.log(this.documentacion)
                        this.loading = false
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
            },
            get_info_new_guest: async function () {
                console.log('GET INFO NEW GUEST')
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/getUser/' + this.$route.params['token'] + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language,
                    },
                };
                axios(config)
                    .then(ok => {
                        this.info = ok.data
                        if(ok.data.length === 0){
                            this.dialog_bloqueo = true
                            console.log('Página Expirada .... overlay = ', this.dialog_bloqueo)
                        } else {
                            this.getDocumentationByUser(ok.data[0])
                        }
                    })
                    .catch(error => {
                        if(error.response && error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data)
                            this.errores = error.response.data
                        else
                        if(error.response.status == 404)
                        {
                            this.$store.commit('snackbar_activate_true')
                            this.$store.commit('snackbar_change_color', 'error')
                            this.$store.commit('snackbar_change_message', 'Token Inválido')
                            setTimeout(this.clear, 3000)
                        }
                    })
                    .finally(() => (this.loading = false))
            },
            clear(){
                this.$store.commit('snackbar_change_color', 'success')
                this.$store.commit('snackbar_activate_false')
            }
        }
    }
</script>

<style scoped>
    .error {
        font-weight: bold;
        color: red;
    }
    .edge {
        border-radius: 8px;
        border-color: #002b48 #002b48 #002b48 #002b48;
        border-width: 3px 3px 3px 3px;
        border-style: solid solid solid solid;
    }
</style>
